export const PROMPT_TEMPLATES = [
    // ──────────────────────────────────────────────────
    // Generales (siempre visibles, sin requiredSources)
    // ──────────────────────────────────────────────────
    {
        id: "general_summary_month",
        labelKey: "dashbo_mcp.playground.prompts.general_summary_month",
        query: "Resumen de inversión y resultados por canal este mes",
        requiredSources: [],
        category: "general"
    },
    {
        id: "general_top_campaigns",
        labelKey: "dashbo_mcp.playground.prompts.general_top_campaigns",
        query: "Top 5 campañas por conversiones últimos 7 días",
        requiredSources: [],
        category: "general"
    },
    {
        id: "general_daily_spend",
        labelKey: "dashbo_mcp.playground.prompts.general_daily_spend",
        query: "Evolución diaria del gasto esta semana",
        requiredSources: [],
        category: "general"
    },

    // ──────────────────────────────────────────────────
    // Google Ads
    // ──────────────────────────────────────────────────
    {
        id: "google_top_cpa",
        labelKey: "dashbo_mcp.playground.prompts.google_top_cpa",
        query: "Top 10 campañas de Google por CPA este mes",
        requiredSources: ["DATA_SOURCE_GOOGLE_ADS"],
        category: "google"
    },
    {
        id: "google_spend_vs_conversions",
        labelKey: "dashbo_mcp.playground.prompts.google_spend_vs_conversions",
        query: "Gasto vs conversiones diario en Google esta semana",
        requiredSources: ["DATA_SOURCE_GOOGLE_ADS"],
        category: "google"
    },
    {
        id: "google_low_ctr",
        labelKey: "dashbo_mcp.playground.prompts.google_low_ctr",
        query: "Campañas de Google con CTR más bajo últimos 14 días",
        requiredSources: ["DATA_SOURCE_GOOGLE_ADS"],
        category: "google"
    },
    {
        id: "google_cpc_compare",
        labelKey: "dashbo_mcp.playground.prompts.google_cpc_compare",
        query: "Comparar CPC de Google entre campañas últimos 30 días",
        requiredSources: ["DATA_SOURCE_GOOGLE_ADS"],
        category: "google"
    },
    {
        id: "google_impressions_cvr",
        labelKey: "dashbo_mcp.playground.prompts.google_impressions_cvr",
        query: "Impresiones y tasa de conversión de Google por campaña este mes",
        requiredSources: ["DATA_SOURCE_GOOGLE_ADS"],
        category: "google"
    },

    // ──────────────────────────────────────────────────
    // Meta / Facebook
    // ──────────────────────────────────────────────────
    {
        id: "meta_reach_frequency",
        labelKey: "dashbo_mcp.playground.prompts.meta_reach_frequency",
        query: "Alcance y frecuencia de Meta por campaña este mes",
        requiredSources: ["DATA_SOURCE_FACEBOOK_ADS"],
        category: "meta"
    },
    {
        id: "meta_cpa_demographics",
        labelKey: "dashbo_mcp.playground.prompts.meta_cpa_demographics",
        query: "CPA de Meta por edad y género últimos 30 días",
        requiredSources: ["DATA_SOURCE_FACEBOOK_ADS"],
        category: "meta"
    },
    {
        id: "meta_pixel_cpl",
        labelKey: "dashbo_mcp.playground.prompts.meta_pixel_cpl",
        query: "Conversiones de Pixel y costo por lead en Meta esta semana",
        requiredSources: ["DATA_SOURCE_FACEBOOK_ADS"],
        category: "meta"
    },
    {
        id: "meta_platform_breakdown",
        labelKey: "dashbo_mcp.playground.prompts.meta_platform_breakdown",
        query: "Impresiones por plataforma (Facebook vs Instagram) este mes",
        requiredSources: ["DATA_SOURCE_FACEBOOK_ADS"],
        category: "meta"
    },
    {
        id: "meta_engagement",
        labelKey: "dashbo_mcp.playground.prompts.meta_engagement",
        query: "Campañas de Meta con mayor engagement últimos 14 días",
        requiredSources: ["DATA_SOURCE_FACEBOOK_ADS"],
        category: "meta"
    },

    // ──────────────────────────────────────────────────
    // GA4
    // ──────────────────────────────────────────────────
    {
        id: "ga4_sessions_bounce",
        labelKey: "dashbo_mcp.playground.prompts.ga4_sessions_bounce",
        query: "Sesiones y tasa de rebote por fuente/medio últimos 7 días",
        requiredSources: ["DATA_SOURCE_GA4"],
        category: "ga4"
    },
    {
        id: "ga4_revenue_landing",
        labelKey: "dashbo_mcp.playground.prompts.ga4_revenue_landing",
        query: "Ingresos y transacciones GA4 por landing page este mes",
        requiredSources: ["DATA_SOURCE_GA4"],
        category: "ga4"
    },
    {
        id: "ga4_new_vs_returning",
        labelKey: "dashbo_mcp.playground.prompts.ga4_new_vs_returning",
        query: "Usuarios nuevos vs recurrentes últimos 30 días",
        requiredSources: ["DATA_SOURCE_GA4"],
        category: "ga4"
    },
    {
        id: "ga4_cvr_device",
        labelKey: "dashbo_mcp.playground.prompts.ga4_cvr_device",
        query: "Tasa de conversión por dispositivo esta semana",
        requiredSources: ["DATA_SOURCE_GA4"],
        category: "ga4"
    },
    {
        id: "ga4_funnel",
        labelKey: "dashbo_mcp.playground.prompts.ga4_funnel",
        query: "Embudo: sesiones → add to cart → purchase últimos 14 días",
        requiredSources: ["DATA_SOURCE_GA4"],
        category: "ga4"
    },

    // ──────────────────────────────────────────────────
    // TikTok
    // ──────────────────────────────────────────────────
    {
        id: "tiktok_cpa_campaign",
        labelKey: "dashbo_mcp.playground.prompts.tiktok_cpa_campaign",
        query: "Gasto y CPA de TikTok por campaña esta semana",
        requiredSources: ["DATA_SOURCE_TIKTOK_ADS"],
        category: "tiktok"
    },
    {
        id: "tiktok_clicks_ctr",
        labelKey: "dashbo_mcp.playground.prompts.tiktok_clicks_ctr",
        query: "Clicks y CTR de TikTok vs presupuesto últimos 14 días",
        requiredSources: ["DATA_SOURCE_TIKTOK_ADS"],
        category: "tiktok"
    },
    {
        id: "tiktok_top_conversions",
        labelKey: "dashbo_mcp.playground.prompts.tiktok_top_conversions",
        query: "Top campañas de TikTok por conversiones este mes",
        requiredSources: ["DATA_SOURCE_TIKTOK_ADS"],
        category: "tiktok"
    },
    {
        id: "tiktok_cpc_daily",
        labelKey: "dashbo_mcp.playground.prompts.tiktok_cpc_daily",
        query: "Evolución diaria del CPC en TikTok esta semana",
        requiredSources: ["DATA_SOURCE_TIKTOK_ADS"],
        category: "tiktok"
    },
    {
        id: "tiktok_impressions_cpm",
        labelKey: "dashbo_mcp.playground.prompts.tiktok_impressions_cpm",
        query: "Impresiones y CPM de TikTok por campaña últimos 30 días",
        requiredSources: ["DATA_SOURCE_TIKTOK_ADS"],
        category: "tiktok"
    },

    // ──────────────────────────────────────────────────
    // LinkedIn
    // ──────────────────────────────────────────────────
    {
        id: "linkedin_cpa_conversions",
        labelKey: "dashbo_mcp.playground.prompts.linkedin_cpa_conversions",
        query: "CPA y conversiones de LinkedIn por campaña este mes",
        requiredSources: ["DATA_SOURCE_LINKEDIN_ADS"],
        category: "linkedin"
    },
    {
        id: "linkedin_clicks_ctr",
        labelKey: "dashbo_mcp.playground.prompts.linkedin_clicks_ctr",
        query: "Clicks y CTR de LinkedIn esta semana",
        requiredSources: ["DATA_SOURCE_LINKEDIN_ADS"],
        category: "linkedin"
    },
    {
        id: "linkedin_daily_spend",
        labelKey: "dashbo_mcp.playground.prompts.linkedin_daily_spend",
        query: "Gasto diario de LinkedIn últimos 14 días",
        requiredSources: ["DATA_SOURCE_LINKEDIN_ADS"],
        category: "linkedin"
    },
    {
        id: "linkedin_cpm_reach",
        labelKey: "dashbo_mcp.playground.prompts.linkedin_cpm_reach",
        query: "CPM y alcance de LinkedIn por campaña últimos 30 días",
        requiredSources: ["DATA_SOURCE_LINKEDIN_ADS"],
        category: "linkedin"
    },
    {
        id: "linkedin_top_cpc",
        labelKey: "dashbo_mcp.playground.prompts.linkedin_top_cpc",
        query: "Top campañas de LinkedIn por CPC este mes",
        requiredSources: ["DATA_SOURCE_LINKEDIN_ADS"],
        category: "linkedin"
    },

    // ──────────────────────────────────────────────────
    // Ecommerce — Tiendanube
    // ──────────────────────────────────────────────────
    {
        id: "tiendanube_revenue_orders",
        labelKey: "dashbo_mcp.playground.prompts.tiendanube_revenue_orders",
        query: "Ingresos y ordenes de ecommerce este mes",
        requiredSources: ["DATA_SOURCE_TIENDA_NUBE"],
        category: "ecommerce"
    },
    {
        id: "tiendanube_aov",
        labelKey: "dashbo_mcp.playground.prompts.tiendanube_aov",
        query: "Valor promedio de orden de ecommerce últimos 30 días",
        requiredSources: ["DATA_SOURCE_TIENDA_NUBE"],
        category: "ecommerce"
    },
    {
        id: "tiendanube_top_products",
        labelKey: "dashbo_mcp.playground.prompts.tiendanube_top_products",
        query: "Ingresos por producto este mes",
        requiredSources: ["DATA_SOURCE_TIENDA_NUBE"],
        category: "ecommerce"
    },
    {
        id: "tiendanube_units_sold",
        labelKey: "dashbo_mcp.playground.prompts.tiendanube_units_sold",
        query: "Unidades vendidas por producto en los últimos 30 días",
        requiredSources: ["DATA_SOURCE_TIENDA_NUBE"],
        category: "ecommerce"
    },
    {
        id: "tiendanube_order_status",
        labelKey: "dashbo_mcp.playground.prompts.tiendanube_order_status",
        query: "Ordenes de ecommerce desglosadas por estado de orden este mes",
        requiredSources: ["DATA_SOURCE_TIENDA_NUBE"],
        category: "ecommerce"
    },

    // ──────────────────────────────────────────────────
    // Ecommerce — Shopify
    // ──────────────────────────────────────────────────
    {
        id: "shopify_revenue_orders",
        labelKey: "dashbo_mcp.playground.prompts.shopify_revenue_orders",
        query: "Ingresos y ordenes de ecommerce este mes",
        requiredSources: ["DATA_SOURCE_SHOPIFY"],
        category: "ecommerce"
    },
    {
        id: "shopify_aov",
        labelKey: "dashbo_mcp.playground.prompts.shopify_aov",
        query: "Valor promedio de orden de ecommerce últimos 30 días",
        requiredSources: ["DATA_SOURCE_SHOPIFY"],
        category: "ecommerce"
    },
    {
        id: "shopify_top_products",
        labelKey: "dashbo_mcp.playground.prompts.shopify_top_products",
        query: "Ingresos por producto este mes",
        requiredSources: ["DATA_SOURCE_SHOPIFY"],
        category: "ecommerce"
    },
    {
        id: "shopify_units_sold",
        labelKey: "dashbo_mcp.playground.prompts.shopify_units_sold",
        query: "Unidades vendidas por producto en los últimos 30 días",
        requiredSources: ["DATA_SOURCE_SHOPIFY"],
        category: "ecommerce"
    },
    {
        id: "shopify_order_status",
        labelKey: "dashbo_mcp.playground.prompts.shopify_order_status",
        query: "Ordenes de ecommerce desglosadas por estado de orden este mes",
        requiredSources: ["DATA_SOURCE_SHOPIFY"],
        category: "ecommerce"
    },

    // ──────────────────────────────────────────────────
    // Cross-channel: Google + Meta
    // ──────────────────────────────────────────────────
    {
        id: "cross_gm_cpa",
        labelKey: "dashbo_mcp.playground.prompts.cross_gm_cpa",
        query: "CPA de Google vs Meta por campaña últimos 30 días",
        requiredSources: ["DATA_SOURCE_GOOGLE_ADS", "DATA_SOURCE_FACEBOOK_ADS"],
        category: "cross"
    },
    {
        id: "cross_gm_conversions",
        labelKey: "dashbo_mcp.playground.prompts.cross_gm_conversions",
        query: "Evolución de conversiones Google vs Meta esta semana",
        requiredSources: ["DATA_SOURCE_GOOGLE_ADS", "DATA_SOURCE_FACEBOOK_ADS"],
        category: "cross"
    },
    {
        id: "cross_gm_cpc",
        labelKey: "dashbo_mcp.playground.prompts.cross_gm_cpc",
        query: "¿Dónde estoy pagando menos por click: Google o Meta?",
        requiredSources: ["DATA_SOURCE_GOOGLE_ADS", "DATA_SOURCE_FACEBOOK_ADS"],
        category: "cross"
    },
    {
        id: "cross_gm_budget_split",
        labelKey: "dashbo_mcp.playground.prompts.cross_gm_budget_split",
        query: "Distribución de gasto Google vs Meta este mes",
        requiredSources: ["DATA_SOURCE_GOOGLE_ADS", "DATA_SOURCE_FACEBOOK_ADS"],
        category: "cross"
    },
    {
        id: "cross_gm_roas",
        labelKey: "dashbo_mcp.playground.prompts.cross_gm_roas",
        query: "ROAS comparado Google vs Meta últimos 14 días",
        requiredSources: ["DATA_SOURCE_GOOGLE_ADS", "DATA_SOURCE_FACEBOOK_ADS"],
        category: "cross"
    },

    // ──────────────────────────────────────────────────
    // Cross-channel: Paid Media + GA4
    // ──────────────────────────────────────────────────
    {
        id: "cross_pga4_roas",
        labelKey: "dashbo_mcp.playground.prompts.cross_pga4_roas",
        query: "ROAS real (ingresos GA4 / gasto ads) por canal este mes",
        requiredSources: ["DATA_SOURCE_GA4"],
        requiredAnySource: ["DATA_SOURCE_GOOGLE_ADS", "DATA_SOURCE_FACEBOOK_ADS", "DATA_SOURCE_TIKTOK_ADS", "DATA_SOURCE_LINKEDIN_ADS"],
        category: "cross"
    },
    {
        id: "cross_pga4_sessions_spend",
        labelKey: "dashbo_mcp.playground.prompts.cross_pga4_sessions_spend",
        query: "Sesiones de GA4 vs gasto publicitario por canal esta semana",
        requiredSources: ["DATA_SOURCE_GA4"],
        requiredAnySource: ["DATA_SOURCE_GOOGLE_ADS", "DATA_SOURCE_FACEBOOK_ADS", "DATA_SOURCE_TIKTOK_ADS", "DATA_SOURCE_LINKEDIN_ADS"],
        category: "cross"
    },
    {
        id: "cross_pga4_bounce_rate",
        labelKey: "dashbo_mcp.playground.prompts.cross_pga4_bounce_rate",
        query: "Tasa de rebote por canal de adquisición pagado últimos 14 días",
        requiredSources: ["DATA_SOURCE_GA4"],
        requiredAnySource: ["DATA_SOURCE_GOOGLE_ADS", "DATA_SOURCE_FACEBOOK_ADS", "DATA_SOURCE_TIKTOK_ADS", "DATA_SOURCE_LINKEDIN_ADS"],
        category: "cross"
    },
    {
        id: "cross_pga4_conversion_gap",
        labelKey: "dashbo_mcp.playground.prompts.cross_pga4_conversion_gap",
        query: "Conversiones GA4 vs conversiones de plataforma este mes",
        requiredSources: ["DATA_SOURCE_GA4"],
        requiredAnySource: ["DATA_SOURCE_GOOGLE_ADS", "DATA_SOURCE_FACEBOOK_ADS", "DATA_SOURCE_TIKTOK_ADS", "DATA_SOURCE_LINKEDIN_ADS"],
        category: "cross"
    },
    {
        id: "cross_pga4_landing_traffic",
        labelKey: "dashbo_mcp.playground.prompts.cross_pga4_landing_traffic",
        query: "Landing pages con más tráfico pago últimos 30 días",
        requiredSources: ["DATA_SOURCE_GA4"],
        requiredAnySource: ["DATA_SOURCE_GOOGLE_ADS", "DATA_SOURCE_FACEBOOK_ADS", "DATA_SOURCE_TIKTOK_ADS", "DATA_SOURCE_LINKEDIN_ADS"],
        category: "cross"
    },

    // ──────────────────────────────────────────────────
    // Cross-channel: Paid Media + Ecommerce
    // ──────────────────────────────────────────────────
    {
        id: "cross_pe_roas",
        labelKey: "dashbo_mcp.playground.prompts.cross_pe_roas",
        query: "ROAS ecommerce: ventas de la tienda vs gasto publicitario este mes",
        requiredAnySource: ["DATA_SOURCE_SHOPIFY", "DATA_SOURCE_TIENDA_NUBE"],
        requiredSources: [],
        category: "cross"
    },
    {
        id: "cross_pe_cpa_real",
        labelKey: "dashbo_mcp.playground.prompts.cross_pe_cpa_real",
        query: "Ecommerce CPA: costo publicitario por orden este mes",
        requiredAnySource: ["DATA_SOURCE_SHOPIFY", "DATA_SOURCE_TIENDA_NUBE"],
        requiredSources: [],
        category: "cross"
    },
    {
        id: "cross_pe_full_overview",
        labelKey: "dashbo_mcp.playground.prompts.cross_pe_full_overview",
        query: "Gasto en ads, ingresos de ecommerce y ROAS este mes",
        requiredAnySource: ["DATA_SOURCE_SHOPIFY", "DATA_SOURCE_TIENDA_NUBE"],
        requiredSources: [],
        category: "cross"
    },
    {
        id: "cross_pe_cpa_aov",
        labelKey: "dashbo_mcp.playground.prompts.cross_pe_cpa_aov",
        query: "CPA de ecommerce y valor promedio de orden ultimos 30 dias",
        requiredAnySource: ["DATA_SOURCE_SHOPIFY", "DATA_SOURCE_TIENDA_NUBE"],
        requiredSources: [],
        category: "cross"
    },
];

/**
 * Filtra templates según data sources disponibles.
 * Mantiene backward compatibility.
 */
export function filterPromptsByDataSources(templates, dataSources) {
    if (!dataSources || dataSources.length === 0) {
        return templates.filter(t => t.requiredSources.length === 0 && !t.requiredAnySource);
    }
    return templates.filter(t => {
        const allRequired = t.requiredSources.every(src => dataSources.includes(src));
        if (!allRequired) return false;
        if (t.requiredAnySource) {
            return t.requiredAnySource.some(src => dataSources.includes(src));
        }
        return true;
    });
}

/**
 * Selecciona un subconjunto inteligente de prompts para un cliente,
 * priorizando cross-channel > platform-specific > general.
 *
 * @param {Array} templates - catálogo completo de PROMPT_TEMPLATES
 * @param {Array} dataSources - data sources del cliente
 * @param {number} maxVisible - cantidad de chips a mostrar (default 5)
 * @returns {Array} subconjunto de templates seleccionados
 */
export function selectPromptsForClient(templates, dataSources, maxVisible = 5) {
    const applicable = filterPromptsByDataSources(templates, dataSources);

    const cross = applicable.filter(t => t.category === "cross");
    const platform = applicable.filter(t => t.category !== "cross" && t.category !== "general");
    const general = applicable.filter(t => t.category === "general");

    const selected = [];

    // 1. Hasta 2 cross-channel
    const shuffledCross = shuffle(cross);
    selected.push(...shuffledCross.slice(0, 2));

    // 2. Hasta 3 platform-specific, rotando entre plataformas
    if (selected.length < maxVisible) {
        const byCategory = {};
        for (const t of platform) {
            if (!byCategory[t.category]) byCategory[t.category] = [];
            byCategory[t.category].push(t);
        }
        // Shuffle cada grupo
        const categories = Object.keys(byCategory);
        for (const cat of categories) {
            byCategory[cat] = shuffle(byCategory[cat]);
        }
        // Round-robin entre categorías
        let catIndex = 0;
        const catPointers = {};
        for (const cat of categories) catPointers[cat] = 0;

        while (selected.length < maxVisible && categories.length > 0) {
            const cat = categories[catIndex % categories.length];
            if (catPointers[cat] < byCategory[cat].length) {
                selected.push(byCategory[cat][catPointers[cat]]);
                catPointers[cat]++;
            }
            catIndex++;
            // Evitar bucle infinito si se agotaron todas las categorías
            const allExhausted = categories.every(c => catPointers[c] >= byCategory[c].length);
            if (allExhausted) break;
        }
    }

    // 3. Rellenar con generales
    if (selected.length < maxVisible) {
        const shuffledGeneral = shuffle(general);
        for (const t of shuffledGeneral) {
            if (selected.length >= maxVisible) break;
            if (!selected.find(s => s.id === t.id)) {
                selected.push(t);
            }
        }
    }

    return selected.slice(0, maxVisible);
}

function shuffle(arr) {
    const copy = [...arr];
    for (let i = copy.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
}
